import React from 'react';
import Col from '../../Col';
import Row from '../../Row';
import moment from 'moment';
import TextEditor from '../../Editor/Editor';
import InboxAnnouncementView from '../InboxAnnouncementView/InboxAnnouncementView';
import './inbox-property-announcements-list.scss';

const InboxPropertyAnnouncementsList = ({
  propertyAnnouncementsList,
  onSetAnnouncement,
  announcement,
}) => {
  return announcement && announcement.id ? (
    <InboxAnnouncementView
      announcement={announcement}
      onSetAnnouncement={onSetAnnouncement}
    />
  ) : (
    <div className="inbox-property-announcements-list">
      {propertyAnnouncementsList &&
        propertyAnnouncementsList.length > 0 &&
        propertyAnnouncementsList.map((amt, i) => {
          return (
            <>
              <Row key={i}>
                <Col md={12} xs={12}>
                  <div className="date-divider">
                    <div className="divider-text" role="presentation">
                      {amt.date}
                    </div>
                  </div>
                </Col>
              </Row>
              {amt.announcements.map((annoucement, i) => {
                return (
                  <div
                    className="announcement-item"
                    onClick={() => onSetAnnouncement(annoucement)}
                  >
                    <div className="announcement-card">
                      <div className="announcement-heading">
                        <h2>
                          <img src="/assets/annoucement.png" />
                          {annoucement.title}
                          <span>
                            {moment(annoucement.announcementDate).format('LT')}
                          </span>
                        </h2>
                      </div>
                      <TextEditor
                        editorState={annoucement.description}
                        readOnly={true}
                      />
                    </div>
                  </div>
                );
              })}
            </>
          );
        })}
    </div>
  );
};

export default InboxPropertyAnnouncementsList;